import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-5 md:py-7 px-4 bg-white" data-id="element-92">
      <div className="max-w-3xl mx-auto" data-id="element-93">
        <div className="border-2 border-primary/20 p-4 md:p-5 text-center bg-[#F7F5F0] rounded-2xl shadow-sm" data-id="element-94">
          <ShieldCheck className="w-8 h-8 md:w-10 md:h-10 text-primary mx-auto mb-2 md:mb-3" data-id="element-95" />
          <h2 className="text-base md:text-xl font-bold text-text-primary mb-1.5 md:mb-2 tracking-tight" data-id="element-96">
            Garantía 30 Días — Riesgo Cero
          </h2>
          <p className="text-xs md:text-sm text-text-primary/80 mb-1.5 md:mb-2 font-medium leading-relaxed" data-id="element-97">
            Probalo durante 30 días completos. Si sentís que no es para vos,
            pedís la devolución y listo.
          </p>
          <p className="text-xs md:text-sm font-bold text-primary uppercase tracking-wide" data-id="element-98">
            Sin preguntas. Sin vueltas.
          </p>
        </div>
      </div>
    </section>;
}